import TagManager from 'react-gtm-module';

import {
  DeferredNavigationProps,
  deferredNavigationFields,
} from './clickTracking';

/**
 * `type` identifies where the main hero rendered: category info pages,
 * landing pages and the homepage each report their own type.
 * The campaign hero reports one type wherever it renders (CIP, CLP, PLP).
 */
export const CLP_HERO_TYPE = 'CLP';
export const CIP_HERO_TYPE = 'CIP';
export const HOMEPAGE_HERO_TYPE = 'homepage';
export const CAMPAIGN_HERO_TYPE = 'campaign hero';

export interface TrackMainHeroCtaClickProps extends DeferredNavigationProps {
  data: {
    /** Path the click happened on, e.g. `/en/products/camping-and-hiking` */
    interactionLocation: string;
    /** Href the CTA navigates to */
    linkUrl: string;
    linkText: string;
    /** 0-based position of the CTA within the hero (up to 3) */
    index: number;
    /** Hero variant reported as `type`; defaults to `CIP_HERO_TYPE`. */
    type?: string;
    coOpBrand: string | null;
  };
}

export const trackMainHeroCtaClick = ({
  data,
  ...deferral
}: TrackMainHeroCtaClickProps) => {
  const {
    interactionLocation,
    linkUrl,
    linkText,
    index,
    type = CIP_HERO_TYPE,
    coOpBrand,
  } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_hero_cta',
      interaction: {
        interaction_location: interactionLocation,
        link_url: linkUrl,
        link_text: linkText,
        // Sent as a string to match the other interaction trackers (see
        // trackPlpHeroEvents) — GA4 reads it as a dimension, not a metric.
        index: index.toString(),
        coop_brand: coOpBrand || null,
        type,
      },
      ...deferredNavigationFields(deferral),
    },
  });
};
